import { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import { login } from '../../api/auth';
import { authState } from '../../RecoilStore';
import './AppManageLoginScreen.scss';

function AppManageLoginScreen() {
  const navigate = useNavigate();
  const setAuth = useSetRecoilState(authState);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const { token, storeId, isSuperAdmin, isMasterAdmin } = await login(email, password);
      setAuth({ token, storeId, isSuperAdmin, isMasterAdmin });
      navigate('/appmanage/orders', { replace: true });
    } catch (err: any) {
      setError(err.response?.data?.message || '로그인에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="LoginScreen">
      <form className="LoginScreen-card" onSubmit={handleSubmit}>
        <h1>카페앱모아 관리자</h1>
        <label>
          이메일
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
        </label>
        <label>
          비밀번호
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </label>
        {error && <p className="LoginScreen-error">{error}</p>}
        <button type="submit" disabled={loading}>
          {loading ? '로그인 중...' : '로그인'}
        </button>
        <div className="LoginScreen-links">
          <Link to="/" className="LoginScreen-link">
            홈
          </Link>
        </div>
      </form>
    </div>
  );
}

export default AppManageLoginScreen;
